import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  fetchWitnessStatementList,
  sendWitnessStatementReminder
} from '../../api/v4';
import { setActiveIncidentRequest } from '../../actions/incidents';
import { REACTIVE_REPORT_TYPES } from '../../constants/constants';
import { useActiveHeirarchy } from '../../utils/useActiveHeirarchy';
import Header from '../../components/Header';
import HeaderAndFooter from '../../components/HeaderAndFooter';
import List from '../../components/List';

function WitnessStatementList() {
  const [statementList, setStatementList] = useState([]);
  const { company } = useActiveHeirarchy();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchWitnessStatementList().then(setStatementList);
  }, []);

  const header = <Header section="Witness Statements" />;

  const columns = [
    { key: 'incidentNumber', label: 'Incident Number' },
    { key: 'witnessName', label: 'Witness Name' },
    {
      key: 'reportType',
      label: 'Incident Type',
      datatype: 'svgs',
      disableSortBy: true,
      accessor: ws => ws.reportType?.map(v => parseInt(v, 10)),
      enum: company?.showAircraft
        ? REACTIVE_REPORT_TYPES.filter(r => !r.label !== 'Spill')
        : REACTIVE_REPORT_TYPES.filter(r => !r.isAircraft)
    },
    {
      key: 'isCompleted',
      label: 'Status',
      enum: ['Open', 'In Progress', 'Completed', 'Not Applicable'],
      accessor: ws =>
        ws.isNa
          ? 'Not Applicable'
          : !ws.hasStarted && !ws.isCompleted
          ? 'Open'
          : ws.isCompleted === false
          ? 'In Progress'
          : 'Completed'
    },
    {
      key: 'externalToken',
      label: 'Internal or External?',
      enum: ['Internal', 'External'],
      accessor: ws => (ws.externalToken ? 'External' : 'Internal')
    }
  ];

  return (
    <HeaderAndFooter Header={header}>
      <List
        data={statementList}
        settings={columns}
        dataIsHash
        saveKey="witnessStatementList"
        name="WitnessStatementList"
        getRowId={row => row._id}
        actions={[
          {
            label: 'Send Reminder',
            color: 'blue',
            onClick: ids => {
              sendWitnessStatementReminder(ids);
            }
          }
        ]}
        hideCheckboxFor={['isCompleted', 'externalToken']}
        rowClick={row => {
          dispatch(
            setActiveIncidentRequest({
              _id: row.incidentId,
              returnPath: '/app/witnessStatementList',
              leavePage: false,
              selectedSection: 'Witness Statements'
            })
          );
        }}
      />
    </HeaderAndFooter>
  );
}

export default WitnessStatementList;
